import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, User, Edit3 } from "lucide-react";
import { useSelector } from "react-redux";

export default function RecipientCard({ state, updateState, applicant, errors = {} }) {
  console.log("STATE56656566", state, updateState )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const dropdownRef = useRef(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4040";
  const cid = [];
  const hasFetched = useRef(false);
  

  // Auto-fill from applicant when component mounts or applicant changes
  useEffect(() => {
    if (applicant && applicant.name && applicant.email) {
      // Auto-fill name and email from applicant
      updateState("recipientName", applicant.name);
      updateState("recipientEmail", applicant.email);

      // Auto-fill address if available from applicant
      if (applicant.address) {
        updateState("recipientAddress", applicant.address);
      }

      // Lock the fields since they're coming from applicant
      setIsLocked(true);
    }
  }, [applicant]); // Re-run if applicant changes

  useEffect(() => {
    if (cid && !hasFetched.current) {
      hasFetched.current = true;
      // fetchEmployees(1);
    }
  }, [cid]);

  const employees = [];

  const employeeList = employees?.data || [];

  const filteredEmployees = employeeList.filter((emp) => {
    if (isLocked) return true;

    const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.toLowerCase();
    const searchStr = (state.recipientName || "").toLowerCase();
    return (
      fullName.includes(searchStr) ||
      emp.email?.toLowerCase().includes(searchStr) ||
      emp.employee_code?.toLowerCase().includes(searchStr)
    );
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectEmployee = (emp) => {
    const fullName = `${emp.first_name || ""} ${emp.last_name || ""}`.trim();

    updateState("recipientName", fullName);
    updateState("recipientEmail", emp.email || "");

    if (emp.address || emp.location) {
      updateState("recipientAddress", emp.address || emp.location || "");
    } else {
      updateState("recipientAddress", "");
    }

    setIsLocked(true);
    setIsDropdownOpen(false);
  };

  const handleSelectOther = () => {
    updateState("recipientName", "");
    updateState("recipientEmail", "");
    updateState("recipientAddress", "");
    setIsLocked(false);
    setIsDropdownOpen(false);
  };

  const getProfileImageUrl = (emp) => {
    let url = emp.profile_url || emp.profileImage || emp.profile_image;
    if (!url) return null;
    if (url.startsWith('/uploads')) {
      return `${BACKEND_URL}${url}`;
    }
    return url;
  };

  // Helper component for input field (same as LetterContentCard style)
  const InputField = ({ label, placeholder, value, onChange, error, readOnly }) => (
    <div className="mb-3">
      <label className="form-label fw-semibold">
        {label}
      </label>
      <input
        type="text"
        className={`form-control ${error ? 'is-invalid' : ''}`}
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        readOnly={readOnly}
        style={{ backgroundColor: readOnly ? "#f8f9fa" : "white" }}
      />
      {error && (
        <div className="invalid-feedback">
          {error}
        </div>
      )}
    </div>
  );

  return (
    <div className="card shadow-sm">
      <div className="card-body p-4">
        <h2 className="card-title fw-bold text-dark mb-4" style={{ fontSize: "18px" }}>
          Recipient Information
        </h2>

        {/* Smart Employee Search Dropdown - Hide if locked from applicant */}
        {!applicant || !applicant.name ? (
          <div className="mb-3" ref={dropdownRef}>
            <label className="form-label fw-semibold">
              Name <span className="text-danger">*</span>
            </label>

            <div style={{ position: "relative" }}>
              <input
                type="text"
                readOnly={isLocked}
                className={`form-control ${errors.recipientName ? 'is-invalid' : ''}`}
                placeholder="Search employee or type custom name..."
                value={state.recipientName || ""}
                onChange={(e) => {
                  if (isLocked) return;
                  updateState("recipientName", e.target.value);
                  setIsDropdownOpen(true);
                }}
                onFocus={() => setIsDropdownOpen(true)}
                onClick={() => setIsDropdownOpen(true)}
                style={{ backgroundColor: isLocked ? "#f8f9fa" : "white" }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  zIndex: 5,
                  color: "#6c757d"
                }}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <ChevronDown
                  size={18}
                  style={{
                    transition: "transform 0.2s",
                    transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)"
                  }}
                />
              </div>
            </div>

            {errors.recipientName && (
              <div className="invalid-feedback d-block">
                {errors.recipientName}
              </div>
            )}

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  marginTop: "4px",
                  backgroundColor: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.02)",
                  zIndex: 1050,
                  overflow: "hidden"
                }}
              >
                <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                  {filteredEmployees?.length > 0 ? (
                    filteredEmployees?.map((emp) => {
                      const profileImg = getProfileImageUrl(emp);

                      return (
                        <div
                          key={emp.id}
                          onClick={() => handleSelectEmployee(emp)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "12px 16px",
                            borderBottom: "1px solid #f1f3f5",
                            cursor: "pointer",
                            transition: "background-color 0.2s"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f8fafc";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#f1f5f9",
                              borderRadius: "50%",
                              flexShrink: 0,
                              overflow: "hidden",
                              border: "1px solid #e9ecef"
                            }}
                          >
                            {profileImg ? (
                              <img
                                src={profileImg}
                                alt={`${emp.first_name} avatar`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover"
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  if (e.target.nextSibling) {
                                    e.target.nextSibling.style.display = "flex";
                                  }
                                }}
                              />
                            ) : null}
                            <User size={18} style={{ display: profileImg ? "none" : "block" }} />
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <p style={{
                              fontWeight: "600",
                              color: "#1e293b",
                              margin: 0,
                              fontSize: "14px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}>
                              {emp.first_name} {emp.last_name}
                            </p>
                            <p style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              margin: "4px 0 0 0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}>
                              {emp.email}
                            </p>
                          </div>
                          <div style={{
                            fontSize: "11px",
                            textTransform: "uppercase",
                            color: "#6c757d",
                            flexShrink: 0
                          }}>
                            {emp.designation || "Employee"}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{
                      padding: "16px",
                      textAlign: "center",
                      color: "#6c757d",
                      fontSize: "13px"
                    }}>
                      No matching employees found.
                    </div>
                  )}
                </div>

                <div style={{
                  borderTop: "1px solid #e9ecef",
                  backgroundColor: "#f8fafc",
                  padding: "8px"
                }}>
                  <div
                    onClick={handleSelectOther}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e9ecef";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        flexShrink: 0,
                        border: "1px solid #dee2e6"
                      }}
                    >
                      <Edit3 size={18} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p style={{
                        fontWeight: "600",
                        color: "#1e293b",
                        margin: 0,
                        fontSize: "14px"
                      }}>
                        Other (Manual Entry)
                      </p>
                      <p style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        margin: "2px 0 0 0"
                      }}>
                        Clear fields and type custom details
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <InputField
            label="Name"
            placeholder="Full name"
            value={state.recipientName}
            onChange={(e) => updateState("recipientName", e.target.value)}
            error={errors.recipientName}
            readOnly={true}
          />
        )}

        {/* Email Field - Always show but with readOnly when from applicant */}
        <InputField
          label="Email"
          placeholder="john@example.com"
          value={state.recipientEmail}
          onChange={(e) => updateState("recipientEmail", e.target.value)}
          error={errors.recipientEmail}
          readOnly={applicant && applicant.email ? true : isLocked}
        />

        {/* Address Field - Using simple textarea like LetterContentCard */}
        <div className="mb-3">
          <label className="form-label fw-semibold">
            Address
          </label>
          <textarea
            rows={5}
            className={`form-control ${errors.recipientAddress ? 'is-invalid' : ''}`}
            placeholder="123 Main St, City, State 12345"
            value={state.recipientAddress || ""}
            onChange={(e) => updateState("recipientAddress", e.target.value)}
            style={{
              resize: 'vertical',
              width: '100%',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflow: 'auto'
            }}
          />
          {errors.recipientAddress && (
            <div className="invalid-feedback">
              {errors.recipientAddress}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}